export default "__VITE_ASSET__CrYnWwPM__"